import actions from './actions'

const initialState = {
  callLogs: [],
  callLogsLoadMoreId: 0,
  callLogsPollingId: 0,
  callLogsLoading: false,
  callSearchLogs: [],
  callSearchLogsLoading: false,
  callSearchLogsTotal: 0,
  callSearchLogsPagination: {},
  callSessionParticipants: [],
  callSessionParticipantsLegacy: [],
  callRecordings: [],
  callActive: [],
  callActiveLegacy: [],
  callSearchLogsLegacy: [],
}

export default function callsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
